$(document).ready(function(){
  $('body').on('click', '#shopify-section-product-recommendations .productCardMain .atcAjaxCard .collectionsQuantity .qtybox .btnqty', function(){
    var quantity = parseInt($(this).siblings('.quantity-selector').val());
    if( $(this).hasClass('qtyminus') ){
      console.log('minus ...');
      if( quantity > 1){ quantity = quantity - 1; } else { quantity = 1; }
    }
    if( $(this).hasClass('qtyplus') ){
      console.log('plus ...');
      if( quantity >= 0){ quantity = quantity + 1; } else { quantity = 1; }
    }
     $(this).siblings('.quantity-selector').val(quantity);
  })  
  
  $(document).on('click','.kit_addToCartBtn', function(){
    $('.product-form__cart-submit').trigger('click');
  })
  $(document).on('click','.cdk_filter_block .filter .title', function(){
    $(this).toggleClass('activeFilter');
    $(this).next('ul.coll-filter').slideToggle();
  })
  $(document).on('change','.cdk_filter_block.filtermob .sort_mobile #cdkSortBy', function(){
    var SortVal = $(this).val();
    $('.filters-toolbar #SortBy').val(SortVal).change();
  })
   
  var ScreenWidth = $(window).width();

  if(ScreenWidth <= '767'){
    $(document).on('click','.cdk_filter_block .refineSearch .mobileCdkToggle', function(){
      $(this).toggleClass('activeItem');
      $('.cdk_filter_block #cdk_Filter').slideToggle();
    })
  }

  
  $('.cdk_mobileslider').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    watchCSS: true,
    prevNextButtons: false,
  }); 
  setTimeout(function(){
  $('.page-width[data-section-id="product-recommendations"] ul.flex.justifyCenter').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    watchCSS: true,
    prevNextButtons: false,
  }); 
  },1500);
  
  if(ScreenWidth <= '600'){
    var navbarScrolled = false;
    $(window).scroll(function (event) {
        var scrollTop = $(this).scrollTop();
      	if(scrollTop <=50){
          if(navbarScrolled){
            $(".site-header").removeClass("onScroll"); 
            navbarScrolled = false;

          }
       } else {
         if(!navbarScrolled){
           $(".site-header").addClass("onScroll");  
           navbarScrolled = true;
         }
       }
      
    });

  }
  
  
})     